import React from 'react';
// Ganti isi <svg> di bawah ini dengan SVG icon custom Anda.
// Pastikan ukuran viewBox="0 0 24 24" agar konsisten dengan icon lain.
export function UsersIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Contoh isi SVG, silakan ganti dengan SVG Anda */}
      <circle cx="8" cy="10" r="4" fill="#4FC3F7"/>
      <circle cx="16" cy="10" r="4" fill="#81D4FA"/>
      <rect x="4" y="16" width="16" height="4" rx="2" fill="#B3E5FC"/>
    </svg>
  );
} 